// extracted by mini-css-extract-plugin
export default {"registrationConfirm":"RegistrationConfirm_registrationConfirm__oEkSM"};